const bonusEngine = {
  INDEX: '/bonus-engine',
  CREATE_BONUS_OFFER: '/bonus-engine/offers/create',
  CREATE_BONUS_CAMPAIGN: '/bonus-engine/campaigns/create',
  UPDATE_BONUS_OFFER: '/bonus-engine/offers/update',
  UPDATE_BONUS_CAMPAIGN: '/bonus-engine/campaigns/update',
}

export default bonusEngine
